import { fetchPaginatedDocs } from "../../helpers/collection";
import { ApiRoute } from "../../utilities/routes";

export const fetchSkillsFrameworksExportDataCsv = () =>
  fetchPaginatedDocs("csv", ApiRoute(`/api/admin/skills_framework/export.csv`));
